module.exports = __webpack_public_path__ + "static/media/HECO.e6cac5a4.svg";